import React from "react";

function Hitechchhoo() {
  return <div>Hitechchhoo</div>;
}

export default Hitechchhoo;
